<upp-client-edit uppDataid="ticketinvoice-client-edit"
    [place]="place"
    [client]="Client"
    (Changed)="OnClientChange($event)">
</upp-client-edit>
<upp-form-buttons>
    <ion-button uppDataid="ticketinvoice-create-button"
        size="large"
        expand="block"
        color="success"
        [disabled]="!CanTicketInvoice"
        (click)="OnInvoice()">
        {{ tr('@place_ticket_do_invoice') }}
    </ion-button>
    <ion-button uppDataid="ticketinvoice-cancel-button"
        expand="block"
        fill="clear"
        color="success"
        (click)="OnCancel()">
        {{tr('@place_ticket_cancel')}}
    </ion-button>
</upp-form-buttons>
